// extracted by mini-css-extract-plugin
module.exports = {"font":"cartTable_font__3SQcv"};